import {LinkText} from '@/components/atoms';
import {API_STATUS} from '@/utils/constants/commonConstants';
import {ROUTES} from '@/utils/constants/routesConstants';

export const cellDataMapperObj = (navigate, downloadRewardReport) => ({
  name: {
    cellData: ({row: {original} = {}}) => (
      <LinkText
        text={original?.name || '—'}
        id={
          original?.name +
          ' ' +
          (original?.rewardId || original?.id || original?.uuid)
        }
        handleClick={() => {
          if (original?.rewardId || original?.id || original?.uuid) {
            navigate(
              `${ROUTES.REWARD_CATALOG_DETAIL.replace(':id', encodeURIComponent(original?.rewardId || original?.id || original?.uuid))}?status=${encodeURIComponent(original?.status)}`
            );
          }
        }}
      />
    ),
    linkHandler: (row) => {
      if (row?.rewardId || row?.id || row?.uuid) {
        navigate(
          `${ROUTES.REWARD_CATALOG_DETAIL.replace(':id', encodeURIComponent(row?.rewardId || row?.id || row?.uuid))}?status=${encodeURIComponent(row?.status)}`
        );
      }
    },
    linkLabel: (row) => row?.name || '—'
  },
  type: {
    render: (row) => {
      return <div>{row?.type || '—'}</div>;
    }
  },
  rewardId: {
    cellData: ({row: {original} = {}}) => <div>{original?.rewardId ?? '—'}</div>
  },
  inventory: {
    cellData: ({row: {original} = {}}) => (
      <div>{original?.inventory ?? '—'}</div>
    )
  },
  reportUrl: {
    downloadHandler: (row) => {
      if (
        row.status?.toLowerCase() === API_STATUS.DRAFT?.toLowerCase() ||
        row.status?.toLowerCase() === API_STATUS.PUBLISHED?.toLowerCase()
      ) {
        return;
      }
      if (downloadRewardReport) {
        downloadRewardReport(row.rewardId || row.id, row.name);
      }
    },
    downloadLabel: (original) => (original?.name || '—') + ' Report',
    render: (row, column) => {
      if (
        row.status?.toLowerCase() === API_STATUS.DRAFT?.toLowerCase() ||
        row.status?.toLowerCase() === API_STATUS.PUBLISHED?.toLowerCase()
      ) {
        return (
          <div className='px-2 py-1 text-gray-500'>
            {(row?.name || '—') + ' Report'}
          </div>
        );
      }
      return (
        <LinkText
          text={column.downloadLabel(row)}
          id={row.rewardId || row.id}
          handleClick={() => column.downloadHandler(row)}
        />
      );
    }
  },
  rewardAcceptance: {
    cellData: ({row: {original} = {}}) => {
      const isLowAcceptance = original?.rewardAcceptance <= 75;
      return (
        <div
          className={isLowAcceptance ? 'bg-red-500 text-white' : ''}
          style={
            isLowAcceptance
              ? {fontWeight: 'bold', padding: '4px', borderRadius: '4px'}
              : {}
          }>
          {original?.rewardAcceptance != null
            ? `${original.rewardAcceptance}%`
            : '—'}
        </div>
      );
    }
  },
  startDate: {
    cellData: ({row: {original} = {}}) => (
      <div>{original?.startDate ?? '—'}</div>
    )
  },
  endDate: {
    cellData: ({row: {original} = {}}) => <div>{original?.endDate ?? '—'}</div>
  },
  updatedAt: {
    cellData: ({row: {original} = {}}) => (
      <div>{original?.updatedAt ?? '—'}</div>
    )
  },
  updatedBy: {
    cellData: ({row: {original} = {}}) => (
      <div>{original?.updatedBy ?? '—'}</div>
    )
  },
  status: {
    cellData: ({row: {original} = {}}) => (
      <div className={original?.status === 'Error' ? 'status_error' : ''}>
        {original?.status ?? '—'}
      </div>
    )
  }
});
